import type { Content, DocContent } from '@webcarelbj/shared-bloks'
import type { RichtextContent } from '@webcarelbj/shared-components'

/**
 * Checks whether the rich text content would result in any content being rendered.
 *
 * @param content
 * @returns {boolean}
 */
export default function willRender(content: Content | DocContent | RichtextContent | undefined): content is DocContent | Content {
  if (typeof content !== 'object') {
    return false
  }

  if (content.type === 'paragraph' || content.type === 'doc') {
    if (content.content === undefined) {
      return false
    } else {
      for (const sub of content.content) {
        if (willRender(sub)) {
          return true
        }
      }
      return false
    }
  } else if (content.type === 'text' && /^\s*$/gm.test(content.text!)) {
    return false
  }

  return true
}
